import api from "@/services/api";

const state = {
  list: [],
};

const mutations = {
  SET_CREDIT_NOTES(state, creditNotes) {
    state.list = creditNotes;
  },
};

const actions = {
  // ================= CREATE =================
  async createCreditNote(_, payload) {
    try {
      const res = await api.post("/credit-notes", payload);
      return res.data;
    } catch (error) {
      console.error("Error creating credit note:", error.message);
      throw error;
    }
  },

  // ================= GET ALL =================
  async getCreditNotes({ commit }) {
    try {
      const res = await api.get("/credit-notes");
      commit("SET_CREDIT_NOTES", res.data);
    } catch (error) {
      console.error("Error fetching credit notes:", error.message);
      throw error;
    }
  },

  // ================= GET BY ID =================
  async getCreditNoteById(_, id) {
    try {
      const res = await api.get(`/credit-notes/${id}`);
      return res.data;
    } catch (error) {
      console.error("Error fetching credit note:", error.message);
      throw error;
    }
  },

  // ================= UPDATE =================
  async updateCreditNote(_, payload) {
    try {
      const id = payload.id;
      const res = await api.put(`/credit-notes/${id}`, payload);
      return res.data;
    } catch (error) {
      console.error("Error updating credit note:", error.message);
      throw error;
    }
  },

  // ================= CANCEL =================
  async cancelCreditNote(_, id) {
    try {
      const res = await api.put(`/credit-notes/${id}/cancel`);
      return res.data;
    } catch (error) {
      console.error("Error cancelling credit note:", error.message);
      throw error;
    }
  },

  // ================= RECORD REFUND =================
  async recordRefund(_, { id, paymentMethod, note }) {
    try {
      const res = await api.put(`/credit-notes/${id}/refund`, { paymentMethod, note });
      return res.data;
    } catch (error) {
      console.error("Error recording refund:", error.message);
      throw error;
    }
  },

  // ================= DELETE =================
  async deleteCreditNote(_, id) {
    try {
      const res = await api.delete(`/credit-notes/${id}`);
      return res.data;
    } catch (error) {
      console.error("Error deleting credit note:", error.message);
      throw error;
    }
  },

  // ================= NEXT NUMBER =================
  async getNextCreditNoteNumber() {
    try {
      const res = await api.get("/credit-notes/next-credit-note-number");
      return res.data.nextCreditNoteNumber;
    } catch (error) {
      console.error("Error fetching next credit note number:", error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
